// extracted by mini-css-extract-plugin
module.exports = {"badgeWiOptions":"BadgeWithOptions_badgeWiOptions__3Rtgz","badgeWiOptions_content":"BadgeWithOptions_badgeWiOptions_content__2Te9i"};